import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { intialPaginationState, showingPageTotalRange, filter, unexpectedError } from '../../common_functions';

const MountConditions = props => {
  const [mountConditions, setMountConditions] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Mount Condition Type',
      dataIndex: 'mcondition',
      key: 'mcondition',
      sorter: true,
      ...filter('mcondition'),
    },
    {
      title: 'Mount Condition Rating',
      dataIndex: 'mtype.name',
      key: 'mtype.name',
      sorter: true,
      ...filter('mtype.name'),
      render: (text, record) => {
        return <>{record?.mtype?.name}</>;
      },
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      sorter: true,
      ...filter('description'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/mount-condition-type/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_mount_condition_type?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_mount_condition_type?.edit ? (
                    <FormOutlined />
                  ) : (
                    <EyeOutlined />
                  )}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'mount_conditions',
              'mount condition rating?',
              mountConditions,
              setMountConditions,
              props?.tabs_permissions?.settings_mount_condition_type?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  useEffect(() => {
    (async () => {
    await getMountConditions(pagination);
  })();
  }, []);
  const getMountConditions = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);
      const response = await props.getItems('mount_conditions', {
        fields: ['id', 'mcondition', 'mtype.name', 'description'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setMountConditions(response.data);
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };
  let handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        if (filters[key]) {
          if (key === 'mtype.name') {
            filtersitems['mtype'] = { name: { _icontains: filters[key][0] } };
          } else {
            filtersitems[key] = { _icontains: filters[key][0] };
          }
        }
      }
    }
    await getMountConditions(pagination, filtersitems, sorter);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/mount-condition-type" }, { title: "Mount Conditions Rating" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Mount Conditions Rating
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.settings_mount_condition_type,
                '/settings/mount-condition-type/new',
                'Create Mount Condition Type'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={mountConditions}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default MountConditions;
